module.exports = __webpack_public_path__ + "img/lobby_hosting_zgw4.c7f8522e.png";